import styled from 'styled-components';

import Button from 'basics/buttons/Button';

import { flexAllCenter, respondDown } from 'styles/mixins';
import { Breakpoints, COLORS } from 'styles/style-constants';

export const SwapRows = styled.div`
    position: relative;
    display: flex;
    flex-direction: column;
    gap: 0.8rem;
`;

export const StyledButton = styled(Button)`
    margin-top: 0.8rem;
    margin-left: auto;

    ${respondDown(Breakpoints.md)`
        width: 100%;
        margin-top: 2rem;
    `}

    ${respondDown(Breakpoints.sm)`
        white-space: normal;
        text-align: center;
        line-height: 130%;
    `}
`;

export const SwapHeader = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 3.2rem;

    h3 {
        font-size: 3.6rem;
        line-height: 4.2rem;
        color: ${COLORS.textPrimary};
        font-weight: 400;
    }

    div {
        ${flexAllCenter};
        padding: 0.5rem;
        border-radius: 0.3rem;
        cursor: pointer;

        &:hover {
            background-color: ${COLORS.gray50};
        }
    }
`;

export const SettingsButton = styled.div`
    ${flexAllCenter};
    border-radius: 50%;
    height: 4rem;
    width: 4rem;
    cursor: pointer;
    position: absolute;
    background-color: ${COLORS.surface};
    border: 0.1rem solid ${COLORS.gray100};
    top: 0;
    left: calc(100% + 1.6rem);

    &:hover {
        border: 0.1rem solid ${COLORS.textGray};
    }

    ${respondDown(Breakpoints.sm)`
       left: calc(100% - 5.6rem);
       top: 1.6rem
    `};
`;

export const TrustlineNotice = styled.div`
    padding: 1.6rem;
    margin-top: 1.6rem;
    border-radius: 1.6rem;
    background-color: ${COLORS.gray50};
    color: ${COLORS.textGray};
    font-size: 1.4rem;
    line-height: 2.2rem;
`;
